module.exports = __webpack_public_path__ + "img/dispatch_car_bg.f56e5391.png";